import { render } from "./TriviaView.vue?vue&type=template&id=63a501d1"
import script from "./TriviaView.vue?vue&type=script&lang=js"
export * from "./TriviaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__